import { NoStyleButton } from "emoreg/atoms/NoStyleButton";
import { color, font, spaces } from "emoreg/const";
import { rem } from "polished";
import styled from "styled-components";

export type VerticalNavigationItem = {
  label: string;
  onClick: () => void;
  isActive?: boolean;
};

const VerticalNavigationList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spaces[8]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

const VerticalNavigationButton = styled(NoStyleButton)<{ $isActive: boolean }>`
  text-align: left;
  font-size: ${rem(14)};
  color: ${({ $isActive }) => ($isActive ? color.grey.darker : "inherit")};
  font-weight: ${({ $isActive }) => ($isActive ? font.weight.semiBold : font.weight.normal)};
  &:hover {
    color: ${color.grey.darker};
  }
  &:focus-visible {
    outline: 2px solid ${color.blue.base};
  }
`;

/**
 * Section navigation of an edit page, usually given to the `leftSidebarComponent` of
 * `ContentComponent`. Routing stays with the caller: it sets `isActive` and navigates in `onClick`.
 */
export const VerticalNavigation = ({ navItems }: { navItems: VerticalNavigationItem[] }) => (
  <nav>
    <VerticalNavigationList>
      {navItems.map(navItem => (
        <li key={navItem.label}>
          <VerticalNavigationButton
            type="button"
            $isActive={!!navItem.isActive}
            aria-current={navItem.isActive ? "page" : undefined}
            onClick={navItem.onClick}
          >
            {navItem.label}
          </VerticalNavigationButton>
        </li>
      ))}
    </VerticalNavigationList>
  </nav>
);
